// import { REDIRECT_URL_KEY } from '@/constants/app.constant';
import { apiSlice } from '../../api-slice';

// import { addBrand } from './brand-slice';

export const brandApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createBrand: builder.mutation({
            query: (data) => ({
                url: 'brands',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Brands'],
        }),

        editBrand: builder.mutation({
            query: (data) => ({
                url: `brands/${data.id}`,
                method: 'PUT',
                body: {
                    name: data.name,
                    description: data.description,
                },
            }),
            invalidatesTags: ['Brands'],
        }),

        getBrands: builder.query({
            query: (params) => {
                return {
                    url: 'brands',
                    method: 'GET',
                    params,
                };
            },
            providesTags: ['Brands'],
            keepUnusedDataFor: 600,
        }),

        deleteBrand: builder.mutation({
            query: (id) => ({
                url: `brands/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Brands'],
        }),
    }),
});

export const {
    useCreateBrandMutation,
    useGetBrandsQuery,
    useEditBrandMutation,
    useDeleteBrandMutation,
} = brandApi;
